<template>
  <content-container :fluid="(framed == false)" :paddingX="false" :paddingY="false" :class="cssBackgroundClass">
    <div
      :class="['flex', 'flex-col', imageSide === 'right' ? 'md:flex-row-reverse' : 'md:flex-row', 'items-center', 'md:gap-0']">
      <div :id="animationId" class="md:basis-1/2 relative flex" :class="[imageSide === 'right' ? 'justify-start': 'justify-end', { 'px-8 md:px-0': framed }, {'lg:transition lg:duration-700 lg:ease-out lg:opacity-0': showAnimation && framed}, {'lg:translate-y-2/4': !animate && showAnimation && framed}, {'lg:opacity-100': animate && showAnimation && framed}]">
        <slot name="picture"></slot>
        <button v-if="video" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-white"
          @click="openVideoModal">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 fill-white/80 hover:fill-white" aria-hidden="true">
            <use :href="iconHref('play')" />
          </svg>
          <span class="sr-only">{{ video.title }}</span>
        </button>
      </div>
      <content-container :fluid="true" :paddingY="true" :class="['prose md:basis-1/2', cssTextClass]">
        <slot></slot>
      </content-container>
    </div>
  </content-container>
  <Dialog :open="videoModalIsOpen" @close="closeVideoModal" as="div"
    class="fixed w-full h-full bg-black/80 flex flex-col items-center top-0 left-0 p-8 z-10" v-if="video">
    <DialogPanel class="bg-white rounded-md overflow-clip w-full lg:w-3/4 my-auto">
      <iframe class="w-full aspect-video" :src="video.src" allow="autoplay; fullscreen; picture-in-picture"
        :title="video.title" allowfullscreen></iframe>
    </DialogPanel>
  </Dialog>
</template>

<script setup>
import { Dialog, DialogPanel } from '@headlessui/vue'
import ContentContainer from '../content-container'
</script>

<script>
import IconPlay from '../../../assets/icons/play.svg'
import {scrollIntoViewObserver} from "../../scroll-into-view-observer";

const iconMap = {
  'play': IconPlay
}

export default {
  name: 'media-section',
  data() {
    return {
      videoModalIsOpen: false,
      animate: false
    }
  },

  props: {
    imageSide: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].includes(value)
      }
    },

    framed: {
      type: Boolean,
      default: false
    },

    background: {
      type: String,
      validator(value) {
        return ['Blue', 'Black', 'Grey', 'White', 'Green'].includes(value)
      }
    },

    video: {
      type: String
    },
    
    showAnimation: {
      type: Boolean,
      default: false
    },
    
    animationId: {
      type: String,
      default: 'media-section'
    }
  },
  
  mounted() {
    if (this.showAnimation && this.framed) {
      let content = document.getElementById(this.animationId)

      scrollIntoViewObserver(content, this.setAnimate)
    }
  },

  computed: {
    cssBackgroundClass() {
      switch (this.background) {
        case "Blue": return 'bg-secondary'
        case "Black": return 'bg-black/80'
        case "Grey": return 'bg-grey-10'
        case "Green": return 'bg-green'
        default: return 'bg-white'
      }
    },

    cssTextClass() {
      switch (this.background) {
        case "Blue": return 'text-white'
        case "Black": return 'text-white'
        default: return null
      }
    }
  },

  methods: {
    closeVideoModal() {
      this.videoModalIsOpen = false
    },

    openVideoModal() {
      this.videoModalIsOpen = true
    },

    iconHref(key) {
      if (iconMap[key]) {
        return '#' + iconMap[key].id
      }

      return null
    },

    setAnimate() {
      this.animate = true
    }
  }
}
</script>